<template>
  <el-container class="index-con">
    <div class="index-header" style="border-bottom: solid 1px #e6e6e6;">
      <navcon></navcon>
    </div>
    <div class="index-page"></div>
    <!-- banner -->
    <div class="banner">
      <el-carousel trigger="click" :height="height + 'px'">
        <el-carousel-item v-for="item,index in banner" :key="index">
          <img class="banner" ref="height1" @load="imgLoad" :src="item.bannerImg" @click="onTransParam(item.transParam)">
        </el-carousel-item>
      </el-carousel>
    </div>

    <div style="padding-top: 40px;">
      <div class="main-con">
        <!-- 分类 -->
        <div class="category">
          <div class="category-item">
            <p class="category-name">类别：</p>
            <ul>
              <li v-for="item,index in categoryList" :key="index" :class="index==categoryCur?'cur':''" @click="onCategory(index,item.id)">{{ item.levelName }}</li>
            </ul>
          </div>
          <div class="category-item">
            <p class="category-name">标签：</p>
            <ul>
              <li v-for="item,index in stateList" :key="index" :class="index==stateCur?'cur':''" @click="onState(index,item.id)">{{ item.labelName }}</li>
            </ul>
          </div>
          <div class="category-item">
            <p class="category-name">类型：</p>
            <ul>
              <li v-for="item,index in shapeList" :key="index" :class="index==shapeCur?'cur':''" @click="onShape(index,item.id)">{{ item.typeName }}</li>
            </ul>
          </div>
        </div>

        <div class="navs-search">
          <div class="nav-lists">
            <ul>
              <li class="type" :class="cur==1?'cur':''" @click="onCur(1)">最新</li>
              <li class="bar divider">|</li>
              <li class="type" :class="cur==2?'cur':''" @click="onCur(2)">最热</li>
              <li class="bar divider">|</li>
              <li class="type" :class="cur==3?'cur':''" @click="onCur(3)">推荐</li>
            </ul>
          </div>
          <div>
            <el-input placeholder="请输入搜索内容" v-model="searchContent" class="input-with-select" @change="getSelect">
              <el-button slot="append" type="warning" icon="el-icon-search" circle @click="getSelect"></el-button>
            </el-input>
          </div>
        </div>

        <!-- 考试列表 -->
        <div class="authentication">
          <div class="grades">
            <ul>
              <li @click="onExamDetails(item.id)" v-for="item,index in courseItem" :key="index">
                <div class="enroll-list-play">
                  <img class="enroll-list-img" :src="item.courseImg">
                  <img class="enroll-list-icon" src="../../assets/img/icon4.png">
                  <p class="enroll-list-label" v-if="item.coursePrice == 0">免费</p>
                </div>
                <div class="grades-title">{{item.courseName}}</div>
                <div class="enroll-list-intotal">
                  <p class="enroll-list-intotal-period">共{{item.durationHour}}课时</p>
                  <p class="enroll-list-intotal-number">{{item.learnCount}}人学习</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="pagination">
          <el-pagination
            background
            layout="prev, pager, next"
            :total="total"
            :current-page="page"
            :page-size="rows"
            @current-change="currentChange">
          </el-pagination>
        </div>
      </div>
    </div>

    <el-footer class="index-footer" style="height: auto; background-color: #f0f4f7;border-top: solid 1px #e6e6e6">
      <footers></footers>
    </el-footer>
  </el-container>
</template>
<script>
// 导入组件
import navcon from '../../components/navcon.vue'
import footers from '../../components/footers.vue'
import { bannerList, subjectList,labelList,typeList, courseLists } from '../../api/userMG'
export default {
  name: 'index',
  data() {
    return {
      showclass: 'asideshow',
      banner:[],
      searchContent:'',
      categoryList:[
      {
          id:'',
          levelName:'全部'
        }
      ],
      categoryCur:'',

      stateList:[
        {
          id:'',
          labelName:'全部'
        }
      ],
      stateCur:'',

      shapeList:[
        {
          id:'',
          typeName:'全部'
        }
      ],
      shapeCur:'',

      cur:1,
      courseItem:[],
      examType:'',
      examStatus:'',
      examForm:'',
      page:1,
      rows:8,
      height:'',
      total:0
    }
  },
  watch: {
    '$route'(to, from) {
      // 更新搜索内容
      this.searchContent = to.query.keyWord;
      // 更新其他可能变化的参数（如 examForm）
      this.examForm = to.query.examForm;
      // 重新获取课程列表
      this.getCourseList();
    }
  },
  // 注册组件
  components: {
    navcon,
    footers,
  },
  created() {
    this.examForm = this.$route.query.examForm;
    this.searchContent = this.$route.query.keyWord;
    
    this.getBannerList();
    this.getClassifyList();
    this.getLabelList();
    this.getTypeList();
    this.getCourseList();
  },
  mmounted() {
    this.imgLoad()
    window.addEventListener('resize',()=>{
      this.height =  this.$refs.height1[0].height
      this.imgLoad()
    })
  },
  methods:{
    imgLoad(){
      var _that = this
      this.$nextTick(()=>{
        _that.height = _that.$refs.height1[0].height
        _that.$emit('style1',_that.height)//如果是子组件，就给父组件传递高度，设定父组件的高度
      })
    },
    // 获取banner
    getBannerList(){
      bannerList({location:3}).then(res => {
        console.log('banner',res.data);
        this.banner = res.data
      })
      .catch(err => {})
    },
    onTransParam(url){
      if(url){
        window.open(url)
      }
    },

    // 获取类别列表
    getClassifyList(){
      subjectList({type:2}).then(res => {
        let categoryList = res.data;
        categoryList.forEach((item,i) => {
          this.categoryList.push({
            id:item.id,
            levelName:item.levelName
          });
        })
      })
    },

    // 获取标签列表
    getLabelList(){
      labelList().then(res => {
        let stateList = res.data.content;
        stateList.forEach((item,i) => {
          this.stateList.push({
            id:item.id,
            labelName:item.labelName
          });
        })
      })
    },

    // 获取类型列表
    getTypeList(){
      typeList().then(res => {
        let shapeList = res.data.content;
        shapeList.forEach((item,i) => {
          this.shapeList.push({
            id:item.id,
            typeName:item.typeName
          });
        })
      })
    },

    // 获取课程列表
    getCourseList(){
      let params = {
        page:this.page,
        rows:this.rows,
        orderType:this.cur,
        subjectId:this.examType,
        label:this.examStatus==0?'':this.examStatus,
        type:this.examForm==0?'':this.examForm,
        searchContent:this.searchContent
      }
      // const loading = this.$loading({
      //   lock: true,
      //   text: '加载中',
      //   spinner: 'el-icon-loading',
      //   background: 'rgba(0, 0, 0, 0.7)'
      // });
      courseLists(params).then(res => {
        console.log('课程数据',res);
        this.total = res.data.total;
        this.courseItem = res.data.content;
        // loading.close();
      })
      // .catch(err => {
      //   loading.close();
      // })
    },
    
    getSelect(){
      this.page = 1;
      this.getCourseList();
    },
    onCategory(e,id){
      this.categoryCur = e;
      this.examType = id;
      this.getCourseList();
    },
    onState(e,id){
      this.stateCur = e;
      this.examStatus = id;
      this.getCourseList();
    },
    onShape(e,id){
      this.shapeCur = e;
      this.examForm = id;
      this.getCourseList();
    },
    onExamDetails(id){
      this.$router.push({path:'/index/classroomDetails',query: { id: id, type:1,path:1 }})
    },
    onCur(e){
      this.cur = e;
      this.getCourseList()
    },
    currentChange(e){
      console.log("分页变化",e)
      this.page = e;
      this.getCourseList();
    },
  }
}
</script>
<style scoped>
  .banner{
    width: 100%;
    cursor: pointer;
  }
  @media (min-width: 1366px) {
    .main-con { 
        width: 1000px;
      }
    }
  @media (min-width: 1600px) {
    .main-con {
      width: 1300px;
    }
  }

  .main-con {
    margin: auto;
    padding-bottom: 40px;
  }
  .index-con {
    height: 100%;
    box-sizing: border-box;
    margin: auto;
  }
  .category{
    padding: 16px 20px;
    border-radius: 8px;
    margin-bottom: 40px;
    background: #fafafa;

  }
  .category-item{
    display: flex;
    align-items: baseline;
    padding: 10px 0;
  }
  .category-name{
    border-left: 3px solid #ff821c;
    padding-left: 6px;
    font-size: 13px;
    line-height: 14px;
    font-weight: 600;
  }
  .category ul{
    flex: 1;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }
  .category ul li{
    font-size: 13px;
    /* font-weight: 600; */
    color: #666666;
    margin: 0 17px 10px;
    padding: 3px 10px;
    cursor: pointer;
  }
  .category ul li:hover{
    color: #ff821c;
  }
  .category ul .cur{
    background: #faede5;
    color: #ff821c;
    border: none !important;
    border-radius: 20px;
  }
  .aside {
    width: 64px !important;
    height: 100%;
    background-color: #334157;
    margin: 0px;
  }
  .asideshow {
    width: 240px !important;
    height: 100%;
    margin: 0px;
  }
  .index-main{
    margin-left: 20px !important;
  }
  .index-header,
  .index-main,
  .index-footer {
    padding: 0px;
    height: auto;
    margin: 0; 
  }

  .navs-search{
    border-bottom: 1px solid #e5e5e5;
    padding: 0 20px 16px;
    margin-top: 20px;
    margin-bottom: 32px;
    display: flex;
    align-content: center;
    justify-content: space-between;
  }
 
  .nav-lists ul{
    display: flex;
    align-items: center;
  }
  .nav-lists ul li{
    font-size: 13px;
    padding: 10px;
    cursor: pointer;
  }
  .divider{
    margin:  0 20px;
  }
  .nav-lists ul .bar{
    color: #e1e2e6;
  }
  .nav-lists ul .type{
    color: black;
  }
  .nav-lists ul .type:hover{
    color: #ff821c;
  }
  .cur{
    color: #ff821c !important;
    border-bottom: 2px solid #ff821c !important;
  }
  .grades ul{
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }
  .grades ul li{
    background-color: #f8f9fb;
    width: 23.5%;
    box-shadow: 0 0 20px rgba(222, 207, 207, 0.8);
    border: 1px solid #e8e9ed;
    border-top: none;
    border-radius: 10px;
    margin-right: 17px;
    margin-bottom: 17px;
    transition: transform 0.3s ease-in-out; /* 动画持续时间和动画类型 */
    transform: translateY(0); /* 初始状态，不移动 */
    position: relative;
  }
  .grades ul li:nth-child(4){
    margin-right: 0;
  }
  .grades ul li:nth-child(8){
    margin-right: 0;
  }
  .grades ul li:nth-child(12){
    margin-right: 0;
  }
  .grades ul li:nth-child(16){
    margin-right: 0;
  }
  .grades ul li:hover{
    background-image: linear-gradient(bottom,#f9efe3 , #fff);
    transform: translateY(-10px)
  }
  
  .grades-title{
    margin:0 16px;
    padding: 10px 0;
    border-bottom: 1px solid #f0f0f0;
    font-size: 14px;
    font-weight: 500;
    color: black;
  }
  .grades ul li .text{
    font-size: 12px;
    color: #686868;
    margin-bottom: 28px;
  }
  .grades .button{
    width: 100%;
    height: auto;
  }
  
  .el-pagination{
    text-align: center;
    margin-top: 25px;
  }
  .enroll-list-play{
    position: relative;
    cursor: pointer;
  }
  .enroll-list-icon{
    position: absolute;
    bottom: 20px;
    left: 20px;
    width: 10px !important;
    height: 10px !important;
    padding: 10px;
    border-radius: 50%;
    background-color: rgba(6, 6, 6, 0.3);
  }
  .enroll-list-img{
    width: 100%;
    /* height: 135px; */
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
  }
  .enroll-list-label{
    background-color: #f16418;
    width: 50px;
    height: 20px;
    font-size: 12px;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    border-top-left-radius: 6px;
    border-bottom-right-radius: 6px;
    position: absolute;
    top: 0;
    left: 0;
  }
  .enroll-list-intotal{
    display: flex;
    align-items: center;
    border-bottom: 1px solid #f2f2f2;
    padding: 10px;
  }
  .enroll-list-intotal-period{
    font-size: 12px;
    padding: 3px 10px;
    border-radius: 20px;
    background: #fcf2e8;
    color: #f16418;
    margin-right: 6px;
  }
  .enroll-list-intotal-number{
    font-size: 12px;
    padding: 2px 10px;
    border-radius: 20px;
    color: #f16418;
    border: 1px solid #fee5d9;
  }
  .input-with-select{
    font-size: 13px;
  }
  .el-input-group__append{
    background-color: #ff821e;
    color: #fff;
    border: 1px solid #ff821e;
  }
  .pagination{
    font-size: 10px;
  }
  .pagination /deep/ .active{
    background: #ff821c !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/index/classroom.vue